import { render, staticRenderFns } from "./edit-icon.vue?vue&type=template&id=6a0818d5&scoped=true&"
import script from "./edit-icon.vue?vue&type=script&lang=js&"
export * from "./edit-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0818d5",
  null
  
)

export default component.exports